import { render, staticRenderFns } from "./attachImg.vue?vue&type=template&id=20bb1e67&scoped=true"
import script from "./attachImg.vue?vue&type=script&lang=js"
export * from "./attachImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bb1e67",
  null
  
)

export default component.exports